export default __webpack_public_path__ + "static/media/logo.eb356a6f.png";